import { make } from 'vuex-pathify'
import Notification from '@/api/notification'
import _ from 'lodash'

const state = {
  notifications: []
}

const getters = {
  ...make.getters(state),

  unRead: (state) => {
    return state.notifications.filter(item => !item.read_at)
  }
}

const mutations = {
  ...make.mutations(state),

  UNSHIFT_NOTIFICATION: (state, payload) => {
    state.notifications.unshift(payload)
  },

  READ_NOTIFICATION: (state, payload) => {
    state.notifications[payload.index].read_at = payload.read_at
  }
}

const actions = {
  async fetch({ commit }) {
    const params = {
      _include: ['sender:id,name,avatar'],
      limit: 10
    }
    try {
      const response = await Notification.index(params)
      commit('SET_NOTIFICATIONS', response.data.notifications)
      return response
    } catch (e) {
      return false
    }
  },

  async read({ state, commit }, id) {
    try {
      const index = _.findIndex(state.notifications, function(o) { return o.id === id })
      if (index !== -1 && !state.notifications[index].read_at) {
        const response = await Notification.read(id)
        commit('READ_NOTIFICATION', {
          index,
          read_at: response.data.notification.read_at
        })
        return response.data.notification
      }
      return true
    } catch (e) {
      return false
    }
  },

  attach({ commit }, payload) {
    commit('UNSHIFT_NOTIFICATION', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
